// extracted by mini-css-extract-plugin
export default {"container":"breadcrumbfavorite_container__mYKYD","mainPageLink":"breadcrumbfavorite_mainPageLink__oSUsW"};